import {TITLE_POSTFIX} from 'app/seo/seo.constants';
import encodeHTML from 'app/helpers/encodeHTMLInStrings';
import Playlist from 'app/components/tv/models/Playlist';
import Video from 'app/components/tv/models/video';

const getDescription = (video: Video) => {
  const matchTitle = video.getMatchTitle() ?? 'Unbekanntes Spiel';
  const competitionName = video.match?.getCompetitionName();
  const matchDay = video.match?.getMatchDay();
  let description = matchTitle;
  if (competitionName) {
    description += ` - ${competitionName}`;
  }
  if (matchDay) {
    description += ` - ${matchDay}`;
  }
  return description + ' - Highlights-Clips auf FuPa.tv';
};

const getSchema = (title: string, description: string, video: Video): string => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: title,
    description: description,
    thumbnailUrl: video.thumbnail?.path ? `${video.thumbnail.path}1920x1080.jpeg` : null,
    duration: 'PT0M20S',
    uploadDate: video.dateCreated,
    contentUrl: video.source,
    provider: {
      '@type': 'Organization',
      name: 'FuPa',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.fupa.net/fupa_logo_180x60.png',
      },
    },
  };

  return encodeHTML(JSON.stringify(schema));
};

const getOgMetaData = (title: string, description: string, pathname: string, imagePath: string) => {
  let meta = [
    {property: 'og:title', content: title},
    {property: 'og:description', content: description},
    {property: 'og:url', content: `https://www.fupa.net${pathname}`},
    {property: 'og:type', content: 'video.other'},
    {property: 'og:locale', content: 'de_DE'},
    {property: 'fb:app_id', content: '939336572887264'},
  ];

  const imageSize = {height: '810', width: '1440'};
  const imageUrl = imagePath ? `${imagePath}${imageSize.width}x${imageSize.height}.jpeg` : '';

  const ogImage = imageUrl
    ? [
        {property: 'og:image', content: imageUrl},
        {property: 'og:image:secure_url', content: imageUrl},
        {property: 'og:image:type', content: 'image/jpeg'},
        {property: 'og:image:width', content: `${imageSize.width}px`},
        {property: 'og:image:height', content: `${imageSize.height}px`},
      ]
    : [];

  meta = meta.concat(ogImage);

  return meta;
};

export const getMetaData = (playlist: Playlist | null, videoSceneSlug: string, pathname: string) => {
  if (!playlist?.hasVideos()) {
    return {};
  }
  const robots = {name: 'robots', content: 'noindex, follow'};

  let videoScene: Video;
  try {
    videoScene = playlist.findBySlug(videoSceneSlug);
  } catch (e) {
    videoScene = playlist.getFirstVideo();
  }
  const videoSceneTitle = videoScene.getTitleWithMinute();
  const matchTitle = videoScene.getMatchTitle();

  const title = `Video: ${videoSceneTitle}${matchTitle ? ` - ${matchTitle}` : ''}`;

  const description = getDescription(videoScene);
  const ogMeta = getOgMetaData(title, description, pathname, videoScene?.thumbnail?.path);
  const schema = getSchema(videoSceneTitle, description, videoScene);

  return {title: title + TITLE_POSTFIX, meta: [...ogMeta, {name: 'description', content: description}, robots], schema};
};
